import styled, { css } from 'styled-components';
import { getFontStyle, rem } from '../../utils';
const cssInputSize = css `
  ${({ inputSize, theme }) => {
    var _a;
    const definedSize = (_a = theme.Form.InputSize[inputSize]) !== null && _a !== void 0 ? _a : theme.Form.InputSize.Medium;
    const width = inputSize === 'Small' ? rem(definedSize.width) : '100%';
    const height = rem(definedSize.height);
    return css `
      width: ${width};
      height: ${height};
    `;
}}
`;
export const StyledWrapper = styled.div `
  position: relative;
  width: 100%;
`;
export const StyledInputWrapper = styled.div `
  position: relative;
  display: inline-flex;
  max-width: 100%;
  ${cssInputSize}
`;
export const StyledLabel = styled.label `
  display: block;
  padding: 0 0 ${({ theme }) => rem(theme.Spacing.Size.XSmall)} 0;
`;
export const StyledLabelRequired = styled.span `
  display: inline-block;
  color: ${({ theme }) => theme.Color.Feedback.Alert};
  white-space: pre-wrap;
`;
export const StyledError = styled.div `
  margin-top: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
`;
export const StyledInputNumber = css `
  appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    display: none;
  }
`;
export const StyledDisabled = css `
  cursor: not-allowed;
  user-select: none;
  opacity: 0.5;
`;
export const StyledInput = styled.input `
  && {
    box-sizing: border-box;
    background: transparent;
    border: ${({ theme, isError }) => `${rem(theme.Border.Size.Small)} solid ${!isError ? theme.Color.Neutrals.Border : theme.Color.Feedback.Alert}`};
    border-radius: ${({ theme, type }) => type === 'number'
    ? rem(theme.Form.Input.Number.Radius)
    : rem(theme.Form.Input.Radius)};
    color: ${({ theme }) => theme.Color.Neutrals.Dark};
    outline: none;
    max-width: 100%;

    &::placeholder {
      color: ${({ theme }) => theme.Form.Input.Placeholder.Color};
    }

    ${cssInputSize}

    ${({ inputSize, theme, extensions }) => {
    const extraPadding = getExtraPadding(theme, extensions);
    return css `
        ${getFontStyle(inputSize === 'Small' ? 'Small' : 'Body')}
        padding: ${inputSize === 'Small'
        ? `${rem(theme.Spacing.Size.XXSmall)} ${rem(theme.Spacing.Size.XSmall + extraPadding)} ${rem(theme.Spacing.Size.XXSmall)} ${rem(theme.Spacing.Size.XSmall)}`
        : `${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.MediumSmall + extraPadding)} ${rem(theme.Spacing.Size.Small)} ${rem(theme.Spacing.Size.Small)}`};
      `;
}}

    &:disabled {
      ${StyledDisabled}
    }
  }

  &[type='number'] {
    ${StyledInputNumber}
    text-align: left;

    ${({ theme }) => css `
      min-width: ${rem(theme.Form.InputSize.Small.width)};
    `}
  }
`;
const getExtraPadding = (theme, extensions) => {
    if (extensions.length === 0) {
        return 0;
    }
    else if (extensions.includes('number-controller')) {
        return theme.Form.InputNumberControllers.Small.width;
    }
    else if (extensions.includes('addons-after')) {
        return theme.Form.InputAddons.width;
    }
};
//# sourceMappingURL=Input.style.js.map